import { Fragment } from 'react/jsx-runtime';
import { IconName, MaterialSymbolIcon } from '@/components/material-symbol-link';
import clsx from 'clsx';
import styles from './info-row.module.css';
import { ReactNode } from 'react';

interface InfoRowProps {
  icon: IconName;
  title: string;
  details?: ReactNode;
  contentClassName?: string;
  detailsTestId?: string;
}

export function InfoRow({ icon, title, details, contentClassName, detailsTestId }: InfoRowProps) {
  return (
    <div className={clsx(styles.row, 'body-3', contentClassName)}>
      <MaterialSymbolIcon name={icon} className={styles.icon} />
      <span className={styles.title}>{title}</span>
      {details && (
        <div
          className={styles.content}
          {...(detailsTestId ? { 'data-testid': detailsTestId } : {})}
        >
          {details}
        </div>
      )}
    </div>
  );
}

interface TextDividerProps {
  details: string[];
}

export function TextDivider({ details }: TextDividerProps) {
  const component = details.map((detail, index) => (
    <Fragment key={index}>
      {detail}
      {index !== details.length - 1 && <span className={styles.divider}>{' | '}</span>}
    </Fragment>
  ));

  return <span>{component}</span>;
}
